var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.visible)?_c('div',{staticClass:"download-hint"},[_vm._v("\n    请下载我们的APP，点击 "),_c('a',{attrs:{"href":_vm.downloadLink,"target":"_blank"}},[_vm._v("这里")]),_vm._v(" 获取下载链接\n    "),_c('button',{on:{"click":_vm.hideHint}},[_vm._v("今天不再提示")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcc0cee6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownloadHint.vue
// module id = aSnq
// module chunks = 170